class ScrollAnimations {
  constructor() {
    this.init();
  }

  init() {
    // Target all headings and paragraphs in RTE formatters and text blocks
    const elementsToAnimate = document.querySelectorAll(`
      .rte-formatter h1,
      .rte-formatter h2,
      .rte-formatter h3,
      .rte-formatter h4,
      .rte-formatter p,
      .text-block h1,
      .text-block h2,
      .text-block h3,
      .text-block h4,
      .text-block p,
      .hero h1,
      .hero h2,
      .resource-card__title,
      .button,
      .button-secondary,
      .image-block img
    `);

    // Add animation class to all elements
    elementsToAnimate.forEach(el => {
      el.classList.add('animate-on-scroll');
    });

    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          // Stop observing after animation
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe all elements
    elementsToAnimate.forEach(el => {
      observer.observe(el);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ScrollAnimations());
} else {
  new ScrollAnimations();
}